<template>
    <div class="article_detail">
        <p class="lead_title" v-text="article.introduction"></p>
        <p class="title" v-text="article.documentTitle"></p>
        <p class="sub_title" v-text="article.subtitle"></p>
        <!-- <p class="reporter" v-if="article.documentAuthor||article.correspondent">
            <span class="author">作者：{{article.documentAuthor}}</span>
            <span class="correspondent">通讯员:{{article.correspondent}}</span>
        </p> -->
        <p class="time" v-if="article.publishTime">
            <span v-text="article.publishTime"></span>
        </p>
        <div class="article_pic" v-if="articleImgs.length>0" v-for="item in articleImgs">
            <img :src="articleAddressPreFix+item.simplePictureLink" alt="">
            <p class="article_pic_title" v-text="item.caption" v-if="item.caption"></p>
        </div>
        <div class="content" v-html="handleHtmlContent(article.documentContent)"></div>
    </div>
</template>
<script>
export default {
    name: 'articleDetail',
    props: {
        article: {
            type: Object,
            required: true
        },
        articleImgs: { //图片列表
            type: Array,
            required: false
        },
        articleAddressPreFix: { //图片路径前缀
            type: String,
            required: true
        }
    }
};
</script>
<style scoped lang="less">
.article_detail {
    width: 100%;

    .lead_title,
    .sub_title {
        font-size: 20px;
        font-weight: 400;
        color: rgba(42, 42, 42, 1);
        line-height: 28px;
        margin-bottom: 15px;
        text-align: center;
    }

    .title {
        font-size: 28px;
        font-weight: 500;
        color: rgba(42, 42, 42, 1);
        line-height: 42px;
        margin-bottom: 15px;
        text-align: center;
    }

    .reporter {
        background: rgba(245, 247, 250, 1);
        padding: 13px 0 12px;
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 20px;
        text-align: center;

        span {
            display: inline-block;
        }

        .author,.correspondent {
            margin-right: 15px;
        }
    }
    .time{
        background: rgba(245, 247, 250, 1);
        padding: 13px 0 12px;
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 20px;
        text-align: center;
        margin-bottom: 20px;
        span {
            display: inline-block;
        }
    }
    .article_pic {
        margin: 10px 0;

        img {
            max-width: 100%;
            object-fit: contain;
            display: block;
            margin: 0 auto;
        }
        .article_pic_title{
            font-size: 14px;
            font-weight: 400;
            width:100%;
            text-align: center;
            line-height: 16px;
            margin-top: 5px;
        }
    }

    .content {
        font-size: 16px;
        font-weight: 400;
        color: rgba(42, 42, 42, 1);
        line-height: 30px;
    }
}
</style>